import { BeerIcon } from './BeerIcon';

/**
 * author: Austin Andrews
 * id 9D9A73D2-0780-4141-95A3-CDFE21E6D4D6
 * name beer
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/beer.svg
 * tags
 * - Food / Drink 
 */
export const CupFullIcon = BeerIcon;
export default CupFullIcon